import { Table, Transaction, User } from '@repo/database/src/types';

export type TransactionDto = Transaction & {
  user: User | null;
  table: Table | null;
  userAlias: string | undefined;
  tableName: string | undefined;
  tournamentName: string | undefined;
};

export interface TransactionResponseDto {
  transactions: TransactionDto[];
  totalCount: number;
  skip: number | undefined;
  take: number | undefined;
}
